import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareDryCleanOnlyIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 0c6.617 0 12 5.383 12 12 0 6.616-5.383 12-12 12-6.616 0-12-5.384-12-12C0 5.383 5.384 0 12 0Zm0 1.411C6.162 1.411 1.412 6.161 1.412 12c0 5.838 4.75 10.588 10.588 10.588 5.838 0 10.588-4.75 10.588-10.588 0-5.838-4.75-10.59-10.588-10.59Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.56 7.904c.95 0 1.667.244 2.154.732.488.487.732 1.17.732 2.049s-.244 1.563-.732 2.055c-.487.492-1.205.734-2.154.725h-2.872v3.847H9.435V7.904h4.125Zm-.421 1.054h-2.451v3.453h2.45c.712.01 1.233-.137 1.561-.435.33-.298.495-.729.495-1.291 0-.563-.164-.99-.495-1.285-.328-.295-.849-.442-1.56-.442Z"
})));

export { productCareDryCleanOnlyIcon as default };
//# sourceMappingURL=productCareDryCleanOnlyIcon.js.map
